<template>
  <div>
    <h1 class="text-h5 mb-4">管理者ダッシュボード</h1>
    <v-row>
      <v-col cols="12" md="6">
        <v-card @click="$router.push({ name: 'AdminClinicList' })" class="pa-4" variant="outlined" hover>
          <v-card-title>
            <v-icon class="mr-2">mdi-hospital-building</v-icon>
            病院管理
          </v-card-title>
          <v-card-text>病院の追加・変更を行います</v-card-text>
        </v-card>
      </v-col>
      <!-- AI-WF#185: 全共通の入金情報設定は廃止（病院単位へ移行）。コメント化して非表示。
           病院ごとの口座は「病院管理」内の各病院カードから編集する。 -->
      <!-- <v-col cols="12" md="6">
        <v-card @click="$router.push({ name: 'AdminBankAccount' })" class="pa-4" variant="outlined" hover>
          <v-card-title>
            <v-icon class="mr-2">mdi-bank</v-icon>
            入金情報設定
          </v-card-title>
          <v-card-text>振込先口座を編集します</v-card-text>
        </v-card>
      </v-col> -->
      <v-col cols="12" md="6">
        <v-card @click="$router.push({ name: 'AdminTaxRate' })" class="pa-4" variant="outlined" hover>
          <v-card-title>
            <v-icon class="mr-2">mdi-percent</v-icon>
            消費税設定
          </v-card-title>
          <v-card-text>消費税率を「有効開始日」付きで管理します</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
